import { useState, useEffect, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { KBContext, ToastContext } from "../index";

import { useKnowledgebase, useAvailableFeatures } from "../../hooks/apis";
import { MetaTags } from "../../Components/MetaTags";

import { FEATURE_FLAG_NEW_AUTH } from "../../Constants/KBContext.constants";
import { codeSnippet } from "../../Constants/utility";
import { amplitudeTracker } from "../../amplitudeTracker";

export default function KBProvider(props) {
  const { setNoNet, setShowToast } = useContext(ToastContext);
  const [customMeta, setCustomMeta] = useState(null);
  const [articleTitle, setArticleTitle] = useState(undefined);
  const [hiddenState, setHiddenState] = useState(false);
  const [showDashboardFooter, setShowDashboardFooter] = useState(false);
  const [searchParams] = useSearchParams();
  const productParam = searchParams.get("product");

  const kbQuery = useKnowledgebase(productParam);
  const featuresQuery = useAvailableFeatures(productParam);

  const data =
    kbQuery.isError || kbQuery.error
      ? false
      : kbQuery.data !== undefined
        ? kbQuery.data
        : true;
  const showCategoryLoader = kbQuery.isLoading;
  const availableFeatures = featuresQuery.data ?? {};
  const isNewAuthFlow = Boolean(availableFeatures[FEATURE_FLAG_NEW_AUTH]);

  useEffect(() => {
    if (data?.title) setArticleTitle(data.title);
  }, [data?.title]);

  useEffect(() => {
    if (kbQuery.data) {
      codeSnippet(kbQuery.data?.codeSnippet);
    }
  }, [kbQuery.data]);

  useEffect(() => {
    if (typeof data?.isInternal === "boolean") {
      window.grexit = { ...window?.grexit, isInternal: data.isInternal };
    }
  }, [data?.isInternal]);

  useEffect(() => {
    if (featuresQuery.isError && featuresQuery.error) {
      if (featuresQuery.error.message === "Network Error") {
        setNoNet(true);
      } else {
        setShowToast("Unable to fetch features for the account.");
      }
    }
  }, [featuresQuery.isError, featuresQuery.error, setNoNet, setShowToast]);

  useEffect(() => {
    if (isNewAuthFlow) {
      window.grexit = { ...window?.grexit, isNewAuthFlow: true };
    }
  }, [isNewAuthFlow]);

  useEffect(() => {
    amplitudeTracker.init(availableFeatures);
  }, [availableFeatures]);

  useEffect(() => {
    if (!hiddenState) {
      const t = setTimeout(() => setHiddenState(true), 10000);
      return () => clearTimeout(t);
    }
  }, [hiddenState]);

  const setData = () => {};

  return (
    <KBContext.Provider
      value={{
        data,
        setData,
        hiddenState,
        showCategoryLoader,
        setHiddenState,
        showDashboardFooter,
        setShowDashboardFooter,
        availableFeatures,
        customMeta,
        setCustomMeta,
        setArticleTitle,
        isNewAuthFlow
      }}
    >
      <MetaTags
        title={articleTitle}
        favIcon={data?.favicon}
        description={data?.description}
        customMeta={customMeta}
        kbTitle={data?.title}
      />
      {props.children}
    </KBContext.Provider>
  );
}
